import React from "react";
import Chart from "react-apexcharts";
import "./DashboardChart.css";
import { GoLinkExternal } from "react-icons/go";
import { Link } from "react-router-dom";
import { encrypt } from "../Utils/Encryption";

const formatValue = (val) => {
  if (typeof val === "number" && val > 1000000000 && val < 9999999999999) {
    const date = val > 9999999999 ? new Date(val) : new Date(val * 1000);
    return date.toLocaleString();
  }
  if (typeof val === "number" && !Number.isInteger(val)) {
    return val.toFixed(2);
  }
  return val;
};

const DashboardLineChart = ({ metricData, status }) => {
  const coordinates = metricData?.coordinates
    ? JSON.parse(metricData.coordinates)
    : {};
  const chartData = JSON.parse(metricData.coordinates || "{}");
  const valueType =
    coordinates?.value_type ?? coordinates?.datasets?.[0]?.value_type ?? "";

  const formatValue = (val) => {
    let formatted = val;
    if (typeof val === "number" && val > 1000000000 && val < 9999999999999) {
      const date = val > 9999999999 ? new Date(val) : new Date(val * 1000);
      formatted = date.toLocaleString();
    } else if (typeof val === "number" && !Number.isInteger(val)) {
      formatted = val.toFixed(2);
    }
    if (valueType === "Nos") {
      return `${formatted} Nos`;
    }
    if (valueType) {
      return `${valueType}${formatted}`;
    }
    return formatted;
  };

  const categories = metricData.value.map((item) => {
    const date = new Date(item.name);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } else {
      return item.name;
    }
  });

  const seriesData = metricData.value.map((item) => parseFloat(item.value));
  const options = {
    chart: {
      type: "line",
      zoom: { enabled: false },
    },
    colors: ["#667eea"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    xaxis: {
      categories: categories,
      title: {
        text: chartData?.xAxis || "X-Axis",
        style: {
          fontWeight: "",
          color: "#666",
          fontSize: "16px",
          fontFamily: "sans-serif",
        },
      },
    },
    yaxis: {
      title: {
        text: chartData?.yAxis || "Y-Axis",
        style: {
          fontWeight: "",
          color: "#666",
          fontSize: "16px",
          fontFamily: "sans-serif",
        },
      },
      labels: {
        formatter: formatValue,
        style: {
          fontWeight: "",
          color: "#666",
          fontSize: "12px",
          fontFamily: "sans-serif",
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: formatValue,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      floating: true,
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
    },
  };

  const series = chartData?.datasets?.map((dataset, index) => {
    return {
      name: dataset.label || `Series ${index + 1}`,
      data: seriesData,
    };
  }) || [
    {
      name: metricData.metric_name || "Series",
      data: seriesData,
    },
  ];

  return (
    <div className="col-12 h-100 ChartData">
      <div className="dashboardCharttitleContainer">
        {metricData?.child && status == 1 && metricData?.metric_id ? (
          <Link
            to={`/dashboard/childmetric/${metricData.metric_name}/${encrypt(
              metricData.metric_id.toString()
            )}/1`}
            className="dashboardCharttitle dashboardCharttitleActive"
          >
            <span className="text-md">{metricData.metric_name}</span>
            <GoLinkExternal className="externelLink" />
          </Link>
        ) : (
          <div className="dashboardCharttitle">
            <span className="text-md">{metricData?.metric_name}</span>
          </div>
        )}
      </div>
      <div className="dashboardChart">
        <Chart
          options={options}
          series={series}
          type="line"
          className="charts"
          width="100%"
          height={350}
        />
      </div>
    </div>
  );
};

export default DashboardLineChart;
